import { useProjectStore } from '../stores/projectStore';

export function useUserRole() {
  const role = useProjectStore((s) => s.currentProject?.user_role);
  return {
    role,
    isViewOnly: role === 'view_only',
    canEdit: role === 'edit' || role === 'full_access',
    hasFullAccess: role === 'full_access',
  };
}
